module.exports = __webpack_public_path__ + "static/media/branchOptimised.7bab3de8.png";